<template>
    <div>
        <v-row>
            <v-col cols="12" md="8">
                <v-card>
                    <v-progress-linear :indeterminate="loading" height="4" style="padding:0; margin:0;"></v-progress-linear>

                    <v-container style="width: 90% !important;" class="my-10">
                        <ValidationProvider :name="item.name"
                                            :rules="item.rules"
                                            mode="eager"
                                            ref="provider"
                                            v-bind:key="item.name"
                                            v-for="item in items">
                            <div slot-scope="{ errors }">
                                <v-row no-gutters>

                                    <!--Label for the form-->
                                    <v-col xs="12" md="3" style="height: 65px" class="d-flex justify-end">
                                        <div class="d-flex align-center justify-end text-right mb-2">
                                            <p class="subtitle-3 font-weight-bold text--primary"
                                               :style="{color: errors.length > 0 ? 'rgb(236 29 36) !important' : '', opacity: 0.8, marginTop: '5px',
                               marginRight: '15px'}">{{ item.title }}:</p>
                                        </div>
                                    </v-col>

                                    <!-- Text field -->
                                    <v-col xs="12" md="9" style="height: 65px">
                                        <v-text-field dense
                                                      :name="item.name"
                                                      outlined
                                                      :placeholder="item.rules && item.rules.includes('required') ? 'Obavezno..' : ''"
                                                      :prepend-icon="item.icon"
                                                      v-if="item.tag === 'input' && item.name != 'jmbg'"
                                                      v-model="form[item.name]">
                                        </v-text-field>

                                        <v-text-field dense
                                                      :name="item.name"
                                                      outlined
                                                      :placeholder="item.rules && item.rules.includes('required') ? 'Obavezno..' : ''"
                                                      :prepend-icon="item.icon"
                                                      v-if="item.tag === 'input' && item.name === 'jmbg'"
                                                      v-model="jmbg"
                                                      :disabled="resource.id > 0 && form.aai_email != null"
                                                      @blur="checkUserRole(jmbg)">
                                          <template #append-outer>
                                            <v-tooltip bottom v-if="resource.id > 0 && form.aai_email != null">
                                              <template v-slot:activator="{ on, attrs }">
                                                <v-icon v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
                                              </template>
                                              <span>Ne možete urediti JMBG korisniku koji posjeduje eduID</span>
                                            </v-tooltip>
                                          </template>
                                        </v-text-field>

                                        <!--<v-text-field dense-->
                                                      <!--:name="item.name"-->
                                                      <!--outlined-->
                                                      <!--:placeholder="item.rules && item.rules.includes('required') ? 'Obavezno..' : ''"-->
                                                      <!--:prepend-icon="item.icon"-->
                                                      <!--v-if="item.tag === 'input' && input.name == 'jmbg'"-->
                                                      <!--v-model="form[item.name]">-->
                                        <!--</v-text-field>-->


                                        <!-- Select field -->
                                        <v-autocomplete outlined
                                                        dense
                                                        :placeholder="item.rules ? 'Obavezno..' : ''"
                                                        :items="item.source"
                                                        :name="item.name"
                                                        :prepend-icon="item.icon"
                                                        item-text="text"
                                                        item-value="value"
                                                        v-if="item.tag === 'select'"
                                                        v-model="form[item.name]">
                                        </v-autocomplete>

                                        <!-- Multiselect field -->

                                        <v-autocomplete outlined
                                                        dense
                                                        :placeholder="item.rules ? 'Obavezno..' : ''"
                                                        :items="item.source"
                                                        :name="item.name"
                                                        chips
                                                        multiple
                                                        v-if="item.tag === 'multiselect'"
                                                        v-model="form[item.name]">
                                        </v-autocomplete>


                                        <!-- HTML editor -->

                                        <div style="height: 320px"
                                             v-if="item.tag === 'html'">
                                            <br/>

                                            <span class="subheading">
                                    {{ item.title }} <br/>
                                </span>

                                            <vue-editor
                                                    :name="item.name"
                                                    style="height: 200px; margin-top: 5px;"
                                                    v-model="form[item.name]">
                                            </vue-editor>

                                            <!--
                                            <p v-if="item.validate"
                                               class="form-error" style="padding: 10px;">
                                                Ovo polje je obavezno.
                                            </p>
                                            -->
                                        </div>

                                        <div class="hidden-sm-and-up" style="height: 60px;"
                                             v-if="item.tag === 'html'"></div>


                                        <!-- File(s) uploads -->

                                        <div v-if="item.tag === 'file' || item.tag === 'files'">
                                            <br/>

                                            <span class="subheading">{{ item.title }} <br/> </span>

                                            <vue-dropzone
                                                    :id="'dropZone_' + item.name"
                                                    :name="item.name"
                                                    :options="item.tag === 'file' ? dzSingle : dzMulti"
                                                    @vdropzone-complete="(file) => onFileUpload(file, item)"
                                                    style="margin-top: 5px;"
                                                    v-if="dropzones">
                                            </vue-dropzone>
                                        </div>


                                        <!-- Date picker -->

                                        <v-menu
                                                v-model="menu"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                transition="scale-transition"
                                                offset-y
                                                min-width="290px"
                                                v-if="item.tag === 'date'"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                        v-model="form[item.name]"
                                                        label="Odaberite datum"
                                                        readonly
                                                        v-bind="attrs"
                                                        v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker v-model="form[item.name]" scrollable>

                                            </v-date-picker>
                                        </v-menu>


                                        <!-- Time picker -->

                                        <br v-if="item.tag === 'time'"/>

                                        <v-time-picker
                                                :landscape="false"
                                                :name="item.name"
                                                format="24hr"
                                                v-if="item.tag === 'time'"
                                                v-model="form[item.name]">
                                        </v-time-picker>

                                    </v-col>
                                </v-row>
                            </div>
                        </ValidationProvider>
                    </v-container>

                </v-card>
            </v-col>

            <v-col cols="12" md="4" >
                <div class="fix-element">
                    <v-btn @click="saveResource()" color="primary" dark block width="100%">
                        Potvrdi
                    </v-btn>

                    <v-btn @click="goBack()" class="mt-4" color="primary" dark block outlined>
                        Odustani
                    </v-btn>
                </div>
            </v-col>
        </v-row>

        <v-dialog
                v-model="dialog" persistent
                max-width="600">

            <v-card>
                <v-card-title style="padding-left: 44px; padding-top:30px;" class="mb-0 pb-0"
                              primary-title>
                    {{ jmbg }}
                    - {{user.full_name}}
                </v-card-title>
              <v-card-title style="padding-left: 44px; padding-top:30px;" class="mt-0 pt-0"
                            primary-title>
                <span style="font-size: 13px;" class="grey--text pt-2">*Dodijelite ulogu korisniku za Vašu školu.</span>
              </v-card-title>


                <v-card-text style="min-height: 200px !important;">

                    <!-- Multiselect field -->

                    <v-container fluid grid-list-sm>
                        <v-layout row wrap>
                            <v-col cols="12" md="6">
                                <v-autocomplete
                                        v-model="form_role.role"
                                        label="Odaberi ulogu"
                                        :items="roles"
                                        :item-text="'title'"
                                        :item-value="'id'"
                                        @change="pickedRole"
                                        chips>
                                </v-autocomplete>
                            </v-col>

                            <v-col cols="12" md="6">
                                <v-btn style="width: 100%; margin: 15px 0;" @click="addRoles()" color="primary">Dodijeli
                                </v-btn>
                            </v-col>


                        </v-layout>
                    </v-container>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="accent" @click="dialog = false">U redu</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import {serverBus} from "../../main";

    import {VueEditor} from 'vue2-editor'
    import VueDropzone from 'vue2-dropzone'

    import {extend, setInteractionMode, ValidationProvider} from 'vee-validate';
    import {digits, email, max, min, required} from 'vee-validate/dist/rules';
    import ApiV2 from '../../services/ApiV2'

    import 'vue2-dropzone/dist/vue2Dropzone.min.css'

    // import FormGenerator from "../add/FormGenerator";

    export default {

        components: {
            VueEditor,
            VueDropzone,
            ValidationProvider
        },

        props: [
            'customTable'
        ],

        created: function () {
            setInteractionMode('eager');

            extend('min', min);
            extend('max', max);
            extend('digits', digits);
            extend('email', email);
            extend('required', {...required, message: 'Ovo polje je obavezno.'});

            this.table = 'djelatnik';
            this.resource.id = this.$route.params.resource_id;
            // console.log(this.resource.id)

            this.getGeneralData();

            setTimeout(function () {
                serverBus.$emit('get-add-view-data');
            }, 30);

            let self = this;
            serverBus.$on('perform-action-after-save', function () {
                self.$navigate('/admin/djelatnik/pregled/' + self.id);
            });

            this.getResource();
            this.getResourceFormData();
            // this.getRoles();

            this.tableActive = this.table;
            // console.log(this.resource.id === undefined)
        },

        methods: {
            saveItem() {
                serverBus.$emit('save-add-view-data');
            },

            getGeneralData() {
                this.$axios.post(this.table + '/opcenito').then(response => {
                    this.breadcrumbs = response.data['breadcrumbs'];
                    this.breadcrumbs.push({text: 'New item'})

                    if (this.title === '') {
                        this.title = response.data['title'];
                    }
                });
            },
            getResourceFormData() {
                if (this.table === this.tableActive) return;

                this.items = null;

                this.$axios.post(this.table + '/obrazac').then(response => {
                    this.items = response.data;
                    //Privremeno rješenje dok se ne popravi api
                    //this.items[2].source = ['OŠ fra Grge Martića', 1, "1"]
                });
            },

            checkUserRole(value) {
              // if (this.resource.id > -1) return;
              // console.log(value)
                let reqBody = {
                  'jmbg': value
                }
                ApiV2.post('check_jmbg/', reqBody )
                    .then(response => {
                        let check_jmbg = response.data
                        // console.log(check_jmbg)
                        if (check_jmbg.exists){
                            this.user = response.data.user
                            this.dialog = true;

                            this.$axios.post('ostalo/uloga/sve').then(response => {
                                this.roles = response.data;
                            });

                            this.$axios.post('ostalo/uloga/options').then(response => {
                                this.schools = response.data.schools;
                                this.cantons = response.data.cantons;
                            });

                            this.getUserRoles();
                            // console.log('postoji')
                        }
                    // console.log(response.data)
                });
            },

            // getRoles() {
            //
            //     this.$axios.post('/ostalo/uloga/korisnik/' + this.$route.params.resource_id)
            //         .then(response => {
            //             this.roles = response.data;
            //             let self = this;
            //             this.$nextTick(() =>{
            //                 self.form.roles = this.roles.map(role => {return role.id})
            //             })
            //             console.log(this.roles)
            //     });
            // },

            getUserRoles() {
                this.$axios.post('ostalo/uloga/korisnik/' + this.user.id).then(response => {
                    const roles_user = response.data;

                    let items = [];

                    for (let i = 0; i < roles_user.length; i++) {
                        switch (roles_user[i].organisation_type) {
                            case 'School':
                                items = this.schools;
                                roles_user[i].organisationTypeText = 'Škola';
                                break;
                            case 'Canton':
                                items = this.cantons;
                                roles_user[i].organisationTypeText = 'Županija';
                                break;
                            case 'Everything':
                                roles_user[i].organisationTypeText = 'Pristup svemu';
                                break;
                            default:
                                this.dropdownItems = [];
                        }

                        for (let j = 0; j < items.length; j++) {
                            if (items[j].value === roles_user[i].organisation_id) {
                                roles_user[i].modelText = items[j].text;
                                break;
                            }
                        }
                    }

                    this.roles_user = roles_user;
                });
            },

            addRoles() {
                this.form_role.organisationId = localStorage.getItem('school_id');
                this.form_role.check_jmbg = this.jmbg
                // console.log(this.form_role)
                this.$axios.post('ostalo/uloga/korisnik/' + this.user.id + '/dodaj', this.form_role)
                    .then(() => {
                        this.getUserRoles();
                        this.dialog = false;
                        serverBus.$emit('show-snackbar', true)
                        this.$navigate('/admin/djelatnik/pregled/' + this.user.id);
                }).catch(function () {
                    serverBus.$emit('show-snackbar', false);
                });
            },

            deleteRole(item) {
                this.form_role.modelRoleId = item.id;

                this.$axios.post('ostalo/uloga/korisnik/' + this.user.id + '/izbrisi', this.form_role).then(() => {
                    this.getUserRoles();
                });
            },

            pickedRole() {
                this.form_role.roleId = this.form_role.role;
                this.dropdownItems = [];

                switch (this.form_role.role) {
                    case 1:
                        this.form_role.organisationType = null;
                        this.form_role.organisationId = null;
                        break;
                    case 2:
                        this.form_role.organisationType = 'Canton';
                        this.dropdownItems = this.cantons;
                        break;
                    default:
                        this.form_role.organisationType = 'School';
                        this.dropdownItems = this.schools;
                }

                if (this.dropdownItems?.length === 1)
                    this.form_role.organisationId = this.dropdownItems[0].value;
            },

            getResource() {
                if (this.resource.id == null || this.resource.id === -1) return;

                this.$axios.post(this.table + '/' + this.resource.id).then(response => {
                    this.form = response.data;
                    this.jmbg = this.form.jmbg
                });
            }
            ,

            saveResource() {
                this.form.jmbg = this.jmbg;
                if (this.resource.id > 0 && this.form.aai_email != null) {
                  delete this.form.jmbg;
                }
                this.loading = true;
                this.$axios.post(this.table + '/spremi', this.form).then((response) => {
                    serverBus.$emit('show-snackbar');
                    this.id = response.data.id

                        this.form = {};

                        serverBus.$emit('close-add-view-dialog');

                    serverBus.$emit('perform-action-after-save');
                }).catch(function (error) {
                    // console.log(error.response.status)
                    if (error.response.status == 422) {
                        // console.log(error.response.data.errors)

                        for (let key in error.response.data.errors) {
                            // console.log(error.response.data.errors[key])
                            serverBus.$emit('show-snackbar', false, error.response.data.errors[key][0]);
                        }
                        // serverBus.$emit('show-snackbar', false, );
                        // console.log(error.response.data);
                        // console.log(error.response.status);
                        // console.log(error.response.headers);
                    } else {
                        serverBus.$emit('show-snackbar', false);
                    }

                }).finally(() => {
                    serverBus.$emit('reload-all-data');

                    this.loading = false;
                });
            },

            onFileUpload(file, item) {
                if (file.accepted) {
                    if (item.tag === 'file') {
                        this.form[item.name] = file.xhr.response;
                    } else if (item.tag === 'files') {
                        if (this.form[item.name] == null) this.form[item.name] = [];

                        this.form[item.name].push(file.xhr.response);
                    }

                    serverBus.$emit('show-snackbar', true,);
                } else {
                    serverBus.$emit('show-snackbar', false);
                }
            },

            goBack(){
                this.$router.go(-1);
            }
        },

        beforeDestroy() {
            serverBus.$off('perform-action-after-save');
        },

        data: function () {
            return {
                dialog: false,
                loading: false,
                breadcrumbs: [],
                id: '',
                table: '',
                title: '',
                resource: {},
                form: {},
                items: [],
                roles: [],
                schools: [],
                cantons: [],
                roles_user: [],
                form_role: {},
                dropdownItems: [],
                jmbg: '',
                user: [],
                dropzones: true,
                tableActive: '',
                dzSingle: {
                    url: 'upload',
                    method: 'POST',
                    maxFilesize: 20,
                    maxFiles: 1,
                    dictDefaultMessage: 'Priložite datoteku..',
                },
                dzMulti: {
                    url: 'upload',
                    method: 'POST',
                    maxFilesize: 20,
                    dictDefaultMessage: 'Priložite jednu ili više datoteka..'
                },
                //Date options
                date: new Date().toISOString().substr(0, 10),
                menu: false
            }
        },
    }
</script>

<style>
    .fix-element {
        position: -webkit-sticky;
        position: sticky;
        top: 5rem;
        align-self: flex-start;
    }
</style>
